// RouteTracker.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch,useSelector } from 'react-redux';
import { setLastVisitedRoute } from  '../../slices/navigation';

export default function RouteTracker (){
  const location = useLocation();
  const dispatch = useDispatch();

 const lastRoute = useSelector(state => state.navigation.lastVisitedRoute);

  useEffect(() => {
    if (!location.pathname.startsWith('/login')) {
      dispatch(setLastVisitedRoute(location.pathname));
    }
  }, [location.pathname]);

  return null;
};